class ThrostlenestProductDrawer extends HTMLElement {
  connectedCallback() {
    if (this.dataset.drawerInitialized === 'true') return;
    this.dataset.drawerInitialized = 'true';

    this.trigger = this.querySelector('[data-drawer-trigger]');
    this.dialog = this.querySelector('[data-drawer-dialog]');
    this.closeButtons = this.querySelectorAll('[data-drawer-close]');

    if (!this.trigger || !this.dialog) return;

    this.returnFocus = null;
    this.closeTimer = null;
    this.animationEndHandler = null;

    this.openDrawer = this.openDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleDialogClick = this.handleDialogClick.bind(this);
    this.handleNativeClose = this.handleNativeClose.bind(this);

    this.trigger.addEventListener('click', this.openDrawer);

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', this.closeDrawer);
    });

    this.dialog.addEventListener('cancel', this.handleCancel);
    this.dialog.addEventListener('click', this.handleDialogClick);
    this.dialog.addEventListener('close', this.handleNativeClose);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.openDrawer);

    this.closeButtons?.forEach((button) => {
      button.removeEventListener('click', this.closeDrawer);
    });

    this.dialog?.removeEventListener('cancel', this.handleCancel);
    this.dialog?.removeEventListener('click', this.handleDialogClick);
    this.dialog?.removeEventListener('close', this.handleNativeClose);

    if (this.closeTimer) {
      window.clearTimeout(this.closeTimer);
    }

    if (this.animationEndHandler && this.dialog) {
      this.dialog.removeEventListener(
        'animationend',
        this.animationEndHandler
      );
    }
  }

  openDrawer() {
    if (this.dialog.open) return;

    this.returnFocus = document.activeElement;

    this.dialog.classList.remove('is-closing');

    this.dialog.showModal();

    document.documentElement.classList.add(
      'throstlenest-drawer-is-open'
    );
  }

  closeDrawer() {
    if (
      !this.dialog.open ||
      this.dialog.classList.contains('is-closing')
    ) {
      return;
    }

    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      this.finishClose();
      return;
    }

    this.dialog.classList.add('is-closing');

    const finishFromAnimation = (event) => {
      if (event.target !== this.dialog) return;

      this.finishClose();
    };

    this.animationEndHandler = finishFromAnimation;

    this.dialog.addEventListener(
      'animationend',
      finishFromAnimation
    );

    this.closeTimer = window.setTimeout(() => {
      this.finishClose();
    }, 1150);
  }

  finishClose() {
    if (this.closeTimer) {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }

    if (this.animationEndHandler) {
      this.dialog.removeEventListener(
        'animationend',
        this.animationEndHandler
      );

      this.animationEndHandler = null;
    }

    if (this.dialog.open) {
      this.dialog.close();
    }

    this.dialog.classList.remove('is-closing');

    document.documentElement.classList.remove(
      'throstlenest-drawer-is-open'
    );

    if (this.returnFocus instanceof HTMLElement) {
      this.returnFocus.focus({
        preventScroll: true
      });
    }
  }

  handleCancel(event) {
    event.preventDefault();

    this.closeDrawer();
  }

  handleDialogClick(event) {
    if (event.target !== this.dialog) return;

    const rect = this.dialog.getBoundingClientRect();

    const clickedInsidePanel =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    if (!clickedInsidePanel) {
      this.closeDrawer();
    }
  }

  handleNativeClose() {
    this.dialog.classList.remove('is-closing');

    document.documentElement.classList.remove(
      'throstlenest-drawer-is-open'
    );
  }
}

if (!customElements.get('throstlenest-product-drawer')) {
  customElements.define(
    'throstlenest-product-drawer',
    ThrostlenestProductDrawer
  );
}